import React from "react";

import { Box, Flex } from "@chakra-ui/react";

import DashboardLogoLink from "elements/DashboardLogoLink";
import LanguageSwitcher from "elements/LanguageSwitcher";

import UserAction from "./UserAction";

const Header: React.FC = () => {
  return (
    <Box
      as="header"
      height={{ base: "56px", lg: "70px" }}
      position="relative"
      width="100%"
      zIndex="10"
      backgroundColor={{ base: "greyscale.300", lg: "transparent" }}
    >
      <Box position={{ base: "absolute", lg: "fixed" }} left={{ base: 4, lg: 10 }} top={{ base: 3, lg: 10 }}>
        <DashboardLogoLink />
      </Box>
      <Flex height="100%" alignItems="center" justifyContent="flex-end" pr={{ base: 4, lg: 8 }} pl={4}>
        <LanguageSwitcher />
        <UserAction />
      </Flex>
    </Box>
  );
};

export default Header;
